import { DietIdEnum, DietModeType } from '@front-activerse/common-components';
import { validateVariablesType } from '../types';

const createRequest = (
  values: any,
  dietTypes: {
    id: number;
    value: DietIdEnum;
    optionTitle: string;
    optionDescription: string;
  }[],
  dietLevels: {
    id: number;
    value: DietIdEnum;
    optionTitle: string;
    optionDescription: string;
  }[],
  appBrand: string
) => {
  const {
    sex,
    heightValue,
    heightUnit,
    weightValue,
    weightUnit,
    dietType,
    dietLevel,
    activityLevel,
    spontaneousActivityLevel,
    dateOfBirth,
    dietMode,
    goalWeightValue,
    goalWeightUnit,
    dietVariant,
  } = values;

  const calculateDietId = () => {
    let dietId = 0;

    if (dietType) {
      dietId = dietTypes.find((type) => type.value === dietType)?.id || 0;
      if (
        dietLevel &&
        (dietType === DietIdEnum.DIET_ID_CLASSIC || dietType === DietIdEnum.DIET_ID_GLP1)
      ) {
        dietId = dietLevels.find((type) => type.value === dietLevel)?.id || 0;
      }
    }

    return dietId;
  };

  const calculateIsVegetarian = () => {
    if (dietLevel === 'DIET_ID_OXY_VEGE' || dietLevel === 'DIET_ID_CLASSIC_SIMPLE_VEGE') {
      return true;
    }
    return false;
  };

  const calculateIsPescoVegetarian = () => {
    if (dietLevel === 'DIET_ID_OXY_VEGE_FISH') {
      return true;
    }
    return false;
  };

  const variables: validateVariablesType = {
    request: {
      weight: weightValue ? { value: weightValue, unit: weightUnit } : null,
      dietMode: dietMode,
      goalWeight:
        dietMode !== DietModeType.stabilization
          ? goalWeightValue
            ? { value: goalWeightValue, unit: goalWeightUnit }
            : null
          : weightValue
          ? { value: weightValue, unit: weightUnit }
          : null,
      dietId: calculateDietId(),
      activityLevel: activityLevel,
      spontaneousActivityLevel: spontaneousActivityLevel,
      sex: sex,
      dateOfBirth: dateOfBirth,
      height: heightValue ? { value: heightValue, unit: heightUnit } : null,
      startDate: new Date().toISOString().slice(0, 10),
    },
  };

  if (appBrand === 'oxy') {
    if (dietType === DietIdEnum.DIET_ID_HIGH_PROTEIN || dietType === DietIdEnum.DIET_ID_ANTY_JOJO) {
      variables.request.dietType = dietVariant || null;
    }

    variables.request.isVegetarian = calculateIsVegetarian();
    variables.request.isPescoVegetarian = calculateIsPescoVegetarian();
  }

  return variables;
};

export default createRequest;
